export enum FibraFacilEnum {
    TypeView = 'fibra-facil',
    Title = 'Limite Fibra Fácil',
    Subtitle = '',
    MessageLimitUnavailable = 'Para saber mais informações sobre o seu limite indisponível entre em contato com nosso atendimento. Caso prefira,  clique abaixo entramos em contato o mais breve possível.'
}

export enum SimulatorLimitUseEnum {
    TypeView = 'simulator-limit-use',
    Title = 'Simulador de uso de limite',
    Subtitle = '',
    DescriptionAlert = 'A taxa de juros do seu contrato é de 8.00% ao mês'
}

export enum SimulatorResultEnum {
    TypeView = 'simulator-result',
    Title = 'Resultado da simulação',
    Subtitle = '',
    TextAlert = 'Isso é apenas uma simulação considerando as condições de taxas e limites atuais. Quando o valor for utilizado, os valores podem variar',
    DescriptionAlert = 'Isso é apenas uma simulação considerando as condições de taxas e limites atuais. Quando o valor for utilizado, os valores podem variar'
}

export enum LimitIncreaseEnum {
    TypeView = 'limit-increase',
    Title = 'Aumento do Limite Fibra Fácil ',
    Subtitle = ''
}

export enum LimitIncreaseResultEnum {
    TypeView = 'limit-increase-result',
    Title = 'Recebemos sua solicitação!',
    Subtitle = ''
}

export enum BlockedBalanceEnum {
    TypeView = 'blocked-balance',
    Title = 'Saldo bloqueado',
    Subtitle = ''
}

export enum DuplicateLinkedAccountEnum {
    TypeView = 'duplicate-linked-account',
    Title = 'Conta Vinculada de Duplicatas',
    Subtitle = ''
}

export enum DetailsTransacionEnum {
    TypeView = 'detail-statement'
}